import Store from '../store'
import interact from 'interactjs'

/*
 | setup draggable windows to attach to anything with class of .draggable and use
 | element with class of .draggable-handle as the drag handle.
 | see http://interactjs.io/ for further config and usage details
 */
export const draggable = () => {
  interact('.draggable')
    .draggable({
      inertia: false,
      // keep the element within the area of it's parent
      restrict: {
        restriction: 'parent',
        endOnly: true,
        elementRect: { top: 0, left: 0, bottom: 0, right: 0 }
      },
      allowFrom: '.draggable-handle',
      onmove: event => {
        // Sync window data with redux
        updateReduxDrag(event)
      }
    })
}

/*
 | setup resizeable windows to attach to anything with class of .resizeable and use
 | element with class of .resizeable-handle as the drag handle.
 | see http://interactjs.io/ for further config and usage details
 */
export const resizeable = () => {
  interact('.resizeable')
    .resizable({
      preserveAspectRatio: false,
      edges: {
        left: false,
        right: '.resizeable-handle',
        bottom: '.resizeable-handle',
        top: false
      }
    })
    .on('resizemove', event => {
      // Sync window data with redux
      updateReduxMove(event)
      scaleChildren(event)
    })
}

const updateReduxDrag = event => {
  // get windowName which is the key to the redux store tracking location data
  const windowName = event.target.getAttribute('data-windowName')
  // create object describing the existing window state
  const interactableWindows = Store.getState().interactableState.windows
  const originalWindowState =
    interactableWindows[windowName] == null
      ? {}
      : { ...interactableWindows[windowName] }
  const newWindowState = {
    ...originalWindowState,
    x: event.dx + (originalWindowState.x || 0),
    y: event.dy + (originalWindowState.y || 0)
  }
  Store.dispatch({ type: 'FORCE_UPDATE_WIDGET', window: newWindowState })
}

const updateReduxMove = event => {
  // get windowName which is the key to the redux store tracking location data
  const windowName = event.target.getAttribute('data-windowName')
  // create object describing the existing window state
  const interactableWindows = Store.getState().interactableState.windows
  const originalWindowState =
    interactableWindows[windowName] == null
      ? {}
      : { ...interactableWindows[windowName] }
  const newWindowState = {
    ...originalWindowState,
    height: parseInt(event.rect.height),
    width: parseInt(event.rect.width)
  }

  Store.dispatch({ type: 'FORCE_UPDATE_WIDGET', window: newWindowState })
}

const scaleChildren = event => {
  const target = event.target
  // Handle scaling of canvas and other divs based on target div
  for (let i = 0; i <= target.children[0].children.length - 1; i++) {
    if (target.children[0].children[i].classList.contains('chart-container')) {
      const chartContainer = target.children[0].children[i]
      for (let j = 0; j <= chartContainer.children.length - 1; j++) {
        if (chartContainer.children[j].classList.contains('chart')) {
          const chart = chartContainer.children[j]
          const height = target.clientHeight
          const width = target.clientWidth
          chartContainer.style.height = height - 80 + 'px'
          chartContainer.style.width = width + 'px'
          chart.style.height = height - 80 + 'px'
          chart.style.width = width + 'px'
        }
      }
    }
  }
}
